// we need to create this function, because the API response is
// different on the order details page than in the sync function

// this function takes into account _extBundleLeasePrice and _bundleLeasePrice
import { OrderBundleTypes, BundleItemTypes } from "../types";

const formatSalesOrderBundles = (
	bundle: OrderBundleTypes,
	salesOrderDetailsItems: { [key: string]: any }[]
) => {
	let formatChildBundle = [];
	let bundleItems = [];
	const primaryItem = bundle.bundleItems.find(
		(bundleItem: { [key: string]: any }) => {
			{
				return (
					bundleItem?.bundleItem?.bundleItemGroup &&
					bundleItem?.bundleItem?.bundleItemGroup?.slug === "primary"
				);
			}
		}
	);

	const extPriceBundlePurchase = salesOrderDetailsItems.find(
		(item: { [key: string]: any }) =>
			item?.bundleItem?.uuid === primaryItem?.bundleItem?.uuid
	)?._extPriceBundlePurchase;


	const extPriceBundlePurchaseLease = salesOrderDetailsItems.find(
		(item: { [key: string]: any }) =>
			item?.bundleItem?.uuid === primaryItem?.bundleItem?.uuid
	)?._extPriceBundleLease;


	if (bundle?.childBundle?.length > 0 && bundle?.childBundle !== null) {
		formatChildBundle = bundle.childBundle.map((child: any) => ({
			bundleItemGroup: child?.bundleItem?.bundleItemGroup,
			uuid: child?.bundleItem?.uuid,
			isActive: child?.bundleItem?.isActive,
			isRequired: child?.bundleItem?.isRequired,
			isVisible: child?.bundleItem?.isVisible,
			quantity: child?.quantity,
			childBundle: {
				name: child?.bundle?.name,
				number: child?.bundle?.number,
				uuid: child?.bundle?.uuid,
				isActive: child?.bundleItem?.isActive,
				bundleItems: child?.bundleItems,
				_bundleUnitPrice: child?._bundleUnitPrice,
				_bundleLeasePrice: child?._bundleLeasePrice,
			},
		}));
	}

	const formatBundleItems = bundle?.bundleItems.map(
		(bundleItem: { [key: string]: any }) => {
 			return {
				bundleItem: bundleItem.bundleItem,
				quantity: bundleItem.quantity,
				_extPriceBundleLease: extPriceBundlePurchaseLease,
				_extPriceBundlePurchase: extPriceBundlePurchase,
				uuid: bundleItem.uuid,
			};
		}
	);

	if (formatChildBundle.length > 0) {
		bundleItems = [...formatBundleItems, ...formatChildBundle];
	} else {
		bundleItems = formatBundleItems;
	}

	return {
		bundleItems: bundleItems,
		quantity: bundle.quantity,
		_extPriceBundlePurchase: extPriceBundlePurchase,
		_extPriceBundleLease: extPriceBundlePurchaseLease,
		bundle: {
			name: primaryItem?.bundleItem.bundle.name,
			number: primaryItem?.bundleItem.bundle.number,
			uuid: primaryItem?.bundleItem.bundle.uuid,
			_bundleMicroImages:
				primaryItem?.bundleItem.bundle._bundleMicroImages,
			_imageUrl: primaryItem?.bundleItem.bundle._imageUrl,
			_includedItems: primaryItem?.bundleItem.bundle._includedItems,
		},
	};
};

export default formatSalesOrderBundles;
